<template>
  <div class="shipper-detail">
    <enterprise
      :form="form"
      :loading="loading"
    />
    <fix-boottom>
      <template slot="button">
        <el-button @click="onReturn">
          返回
        </el-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import FixBoottom from '@/components/FixBoottom/index.vue';
import { detail } from '@/api/warehouse';
import Enterprise from './components/Enterprise.vue';

export default {
  name: 'GoodsDetail',
  components: {
    Enterprise,
    FixBoottom,
  },
  data() {
    return {
      form: {},
      loading: false,
    };
  },
  created() {
    const { id } = this.$route.query;
    this.loading = true;
    detail(id).then((res) => {
      const data = res || {};
      this.form = data;
      this.loading = false;
    });
  },
  methods: {
    onReturn() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.shipper-detail {
  padding-bottom: 50px;
}
</style>
